<pbc-filter [config]="ProjekteFilterConfig" [filter]="projekte.filter$ | async" (filterChange)="projekte.filter$.next($event)"></pbc-filter>
